import { Link } from "react-router";

import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

import { ACTIVITY_TYPE_CONFIG } from "@/features/account/config";
import { activitySummary } from "@/features/account/helpers";
import { AccountActivityEntry } from "@/features/account/types";
import { formatAbsoluteDateTime, formatRelativeDate } from "@/shared/lib/utils/date";

interface AccountActivityRowProps {
  activity: AccountActivityEntry;
}

export function AccountActivityRow({ activity }: AccountActivityRowProps) {
  // Falls back gracefully if the API ever introduces an activity type the UI doesn't know about.
  const config = ACTIVITY_TYPE_CONFIG[activity.type] ?? ACTIVITY_TYPE_CONFIG.TicketCreated;
  const Icon = config.icon;

  const content = (
    <div className="flex items-start gap-4 px-6 py-4">
      <div className={`mt-0.5 flex size-7 shrink-0 items-center justify-center ${config.bgClass}`}>
        <Icon className={`size-3.5 ${config.iconClass}`} />
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <p className="truncate text-sm font-medium">{activitySummary(activity)}</p>
        <p className="text-xs text-muted-foreground">
          {activity.ticketKey && <span className="font-mono">{activity.ticketKey}</span>}
          {activity.ticketKey && " · "}
          {activity.projectName}
        </p>
      </div>
      <Tooltip delayDuration={400}>
        <TooltipTrigger asChild>
          <span className="shrink-0 text-xs text-muted-foreground">{formatRelativeDate(activity.createdAt)}</span>
        </TooltipTrigger>
        <TooltipContent>{formatAbsoluteDateTime(activity.createdAt)}</TooltipContent>
      </Tooltip>
    </div>
  );

  const to = activity.ticketId ? `/projects/${activity.projectId}/tickets/${activity.ticketId}` : `/projects/${activity.projectId}`;

  return (
    <Link to={to} className="block transition-colors hover:bg-muted/50">
      {content}
    </Link>
  );
}
